export const workData = [
    {
        "step": "01",
        "title": "Initial Consultation",
        "desc": "We begin by understanding your business needs and objectives.",
    },
    {
        "step": "02",
        "title": "Requirement Analysis",
        "desc": "We analyze your requirements to plan the best approach.",
    },
    {
        "step": "03",
        "title": "Design and Proposal",
        "desc": "We create a design and proposal tailored to your needs.",
    },
    {
        "step": "04",
        "title": "Development",
        "desc": "Our team develops the solution using the latest technologies.",
    },
    {
        "step": "05",
        "title": "Testing",
        "desc": "We rigorously test to ensure quality and reliability.",
    },
    {
        "step": "06",
        "title": "Deployment",
        "desc": "We deploy the solution and ensure everything runs smoothly.",
    },
    {
        "step": "07",
        "title": "Support and Maintenance",
        "desc": "We provide ongoing support and updates as needed.",
    },
];